import request from '@/utils/request'

/**
 * 查询监控大屏数据
 * @param {string} worklineCode - 产线号（可选，不传则返回所有产线数据）
 */
export function getScadaDashboard(worklineCode) {
  return request({
    url: '/api/open/scadaboard',
    method: 'get',
    params: worklineCode ? { worklineCode } : {}
  })
}
